export default __webpack_public_path__ + "static/media/arrow-rounded-down-12x7.425f5f0f.svg";